export class DailyEngagedUsersMonthlyUsage {
  botName!: string;
  botId!: string;

  dailyEngagedUserTotal = 0;
  activeMessageTotal = 0;

  constructor(data: Partial<DailyEngagedUsersMonthlyUsage & { metricConsumption?: { metricId: string, total: number }[] }>) {
    Object.assign(this, data);

    if (data.metricConsumption?.length) {
      const deu = data.metricConsumption.find(m => m.metricId === 'DailyEngagedUser');
      const am  = data.metricConsumption.find(m => m.metricId === 'ActiveMessage');

      this.dailyEngagedUserTotal = deu?.total ?? 0;
      this.activeMessageTotal   = am?.total ?? 0;
    }
  }
}